import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';

const Wrapper = styled.div`
  padding-right: 1.041vw;
  padding-left: 1.041vw;
  height: 3.8vw;
  width: 10.046vw;
  border-radius: 1.041vw;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) => (props.redAlarm ? 'red' : props.theme.inputBackground)};
`;

const DigitalTimer = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  color: ${(props) => (props.redAlarm ? 'red' : props.theme.textPrimary)};
  font-size: 1.56vw;
`;

const Clock = styled.div`
  width: 2.6vw;
  height: 2.6vw;
  border: 2px solid ${(props) => (props.redAlarm ? 'red' : props.theme.textPrimary)};
  border-radius: 50%;
  position: relative;
`;

const Minut = styled.div`
  width: 2px;
  height: 0.75vw;
  background-color: ${(props) => (props.redAlarm ? 'red' : props.theme.textPrimary)};
  border-top-left-radius: 2px;
  position: absolute;
  top: calc(50% - 0.75vw);
  left: calc(50% - 1px);
  transform-origin: 50% 100%;
  transform: rotate(${(props) => props.rotateAngle}deg);
`;

const Second = styled.div`
  width: 2px;
  height: 1vw;
  background-color: ${(props) => (props.redAlarm ? 'red' : props.theme.textPrimary)};
  border-top-left-radius: 2px;
  position: absolute;
  top: calc(50% - 1vw);
  left: calc(50% - 1px);
  transform-origin: 50% 100%;
  transform: rotate(${(props) => props.rotateAngle}deg);
`;

const Timer = (props) => {
  const { theme } = useContext(ThemeContext);
  return (
    <Wrapper theme={theme} redAlarm={props.timeLeft === 0}>
      <Clock theme={theme} redAlarm={props.timeLeft < 60 && props.timeLeft !== 0}>
        <Minut
          theme={theme}
          redAlarm={props.timeLeft < 60 && props.timeLeft !== 0}
          rotateAngle={(300 - props.timeLeft) / 10}
        />
        <Second
          theme={theme}
          redAlarm={props.timeLeft < 60 && props.timeLeft !== 0}
          rotateAngle={((300 - props.timeLeft) % 60) * 6}
        />
      </Clock>
      <DigitalTimer theme={theme} redAlarm={props.timeLeft < 60 && props.timeLeft !== 0}>
        {'0' + Math.floor(props.timeLeft / 60) + ':'}{' '}
        {props.timeLeft % 60 < 10 ? '0' + (props.timeLeft % 60) : props.timeLeft % 60}
      </DigitalTimer>
    </Wrapper>
  );
};

export default Timer;
